import React from 'react'
import AdminAdverts from '../../Component/adminComp/AdminAdverts'

const AdminAdvertTasks = () => {
  return (


      <AdminAdverts/>
 
  )
}

export default AdminAdvertTasks